module.exports = __webpack_public_path__ + "img/oracle.6ff696a2.svg";